import { useNavigate } from 'react-router-dom'
import { ICONS } from '../../../common/constants'
import fetchAPI from '../../../common/fetchAPI'
import useMatchMutate from '../../../common/hooks/useMatchMutate'
import useModal from '../../../common/hooks/useModal'
import useToast from '../../../common/hooks/useToast'
import ResourceList from '../../../components/admin/ResourceList'
import ConfirmModalContent from '../../../components/common/ConfirmModalContent'

const filterFields = {
    sort: {
        title: {
            label: 'Title',
            dbFields: ['title'],
            asc: true,
        },
        createdAt: {
            label: 'Created at',
            dbFields: ['createdAt'],
            asc: false,
        },
    },
}

export default function ProjectsList({ orgId }) {
    const navigate = useNavigate()
    const { setModal, setModalLoading, isModalLoading } = useModal()
    const setToast = useToast()
    const matchMutate = useMatchMutate()

    function handleDelete(item) {
        setModal(
            <ConfirmModalContent
                onConfirm={async () => {
                    if (isModalLoading) return
                    setModalLoading(true)

                    const { error } = await fetchAPI(
                        `/v1/tasks/projects/${item.id}`,
                        {},
                        'DELETE',
                    )

                    setModal(null)
                    setModalLoading(false)

                    if (error) {
                        setToast(error, 'alert')
                        return
                    }

                    setToast('Project deleted')
                    matchMutate(/\/v1\/tasks\/projects/)
                }}
            />,
            'Are you sure you want to delete this project?',
        )
    }

    return (
        <ResourceList
            newItemBtnText={orgId ? 'New project' : null}
            renderMainButton={!orgId}
            newItemLabel={'New project'}
            newItemPath={`/projects/new${
                orgId ? `?organizationId=${orgId}` : ''
            }`}
            apiUrl={'/v1/tasks/projects'}
            getItemsFromResponse={(data) => data?.results}
            itemClickPath={'/projects/:item.id'}
            paginated={true}
            initialQuery={orgId ? { organizationId: orgId } : undefined}
            paginationLimit={20}
            filters={filterFields}
            fields={[
                {
                    column: 1,
                    getValue: (item) => item.title,
                    getClassName: () => 'title',
                },
            ]}
            actions={[
                {
                    title: 'Edit',
                    onClick: (item) => navigate(`/projects/${item.id}/edit`),
                    icon: ICONS.EDIT_GRAY,
                },
                {
                    title: 'Delete',
                    onClick: handleDelete,
                    icon: ICONS.TRASH_RED,
                    type: 'alert',
                },
            ]}
        />
    )
}
